import { render, staticRenderFns } from "./mdPageination.vue?vue&type=template&id=a4a4dfb2&scoped=true&"
import script from "./mdPageination.vue?vue&type=script&lang=js&"
export * from "./mdPageination.vue?vue&type=script&lang=js&"
import style0 from "./mdPageination.vue?vue&type=style&index=0&id=a4a4dfb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a4dfb2",
  null
  
)

export default component.exports